module.exports = __webpack_public_path__ + "img/banner5.ea9e105c.png";